<script lang="ts">
  import { circInOut } from "svelte/easing"
  import type { Fn } from "../../global"
  import { i18n } from "../../Services/i18n"
  import LangSelect from "./LangSelect.svelte"

  export let isOpen: boolean
  export let toggle: Fn = undefined

  function sidebar() {
    return {
      delay: 0,
      duration: 500,
      easing: circInOut,
      css: (...[, u]: number[]) => `transform: translateX(${100 * u}%)`,
    }
  }
</script>

{#if isOpen}
  <div class="sidebar" transition:sidebar|local>
    <header>
      <button type="button" on:click={() => toggle?.()}> x </button>
    </header>
    <div class="content">
      <slot />
    </div>
    <div class="lang-select">
      <small>{$i18n('Seleccione su idioma')}</small><br>
      <LangSelect />
    </div>
  </div>
{/if}

<style lang="scss">
  .sidebar {
    position: fixed;
    z-index: 300;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 300px;
    background-color: var(--color-primary);
    color: #fff;
    display: flex;
    flex-direction: column;
  }

  header {
    padding: 0.5rem;
    display: flex;
    justify-content: flex-end;
  }

  .content {
    flex: 1 1 0;
  }
  .lang-select {
    padding: 0.5rem;
  }
</style>
